import { NestedCategories } from '~/shared/api'

export const getNamesFromCategory = (category: NestedCategories) => {
  const names: string[] = []

  const traverse = (currentCategory: NestedCategories) => {
    names.push(currentCategory.name)
    if (currentCategory.categories) {
      currentCategory.categories.forEach((el) => traverse(el))
    }
  }

  traverse(category)
  return names
}
